import { PROGRAM_TARGET } from '@admin_pages/OwnerProgram/constants';
import { dayjs } from '@/utils/formatter';
import { BUTTON_ACTION, CTA_POSITIONS } from '../constants';

const makeDefaultButton = () => ({
  label: '',
  action: BUTTON_ACTION.SUBMIT,
  url: '',
  textFields: [],
});

const mapCtaToButton = cta => {
  const button = makeDefaultButton();

  button.label = cta.label || '';
  button.action = cta.action_type || BUTTON_ACTION.SUBMIT;

  if (button.action === BUTTON_ACTION.OPEN_LINK) {
    button.url = cta.action_config?.url || '';
  } else if (button.action === BUTTON_ACTION.FILL_DATA) {
    button.textFields = (cta.action_config?.fields || []).map(field => ({
      title: field.name || '',
      inputType: field.type || 'text',
    }));
  }

  return button;
};

export const mapProgramDetailToForm = program => {
  const ctas = Array.isArray(program.ctas) ? program.ctas : [];

  const buttons = [makeDefaultButton(), makeDefaultButton()];
  ctas.forEach(cta => {
    const index = CTA_POSITIONS.indexOf(cta.position);

    if (index !== -1) {
      buttons[index] = mapCtaToButton(cta);
    }
  });

  return {
    programInformation: {
      name: program.name || '',
      description: program.description || '',
      startDate: program.start_date ? dayjs(program.start_date).toDate() : null,
      endDate: program.end_date ? dayjs(program.end_date).toDate() : null,
      quota: program.quota ? String(program.quota) : '',
      banner: program.banner?.url || null,
    },
    bannerMediaId: program.banner?.media_id ?? null,
    buttonSettings: {
      ctaType: ctas.length > 1 ? 'double' : 'single',
      buttons,
    },
    programTarget: {
      targetType: program.target_type || PROGRAM_TARGET.ALL,
      csvFile: {
        file: null,
        url: program.target_csv || null,
        isDeleting: false,
        deleted: false,
        error: '',
      },
    },
  };
};
